import { formatPrice, type OrderDto } from '@posilka/shared';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { raiseOrderPrice, useOrderMutation, usePriceSuggestion } from '@posilka/client/api/orders';
import { PriceInput } from '@/components/PriceInput';
import { Section } from '@/components/Section';
import { useErrorMessage } from '@/hooks/useErrorMessage';
import { haptic } from '@/lib/telegram';

/** Hech kim olmayotgan OPEN buyurtma: yuboruvchi narxni oshiradi → shafyorlarga qayta xabar. */
export function RaisePrice({ order }: { order: OrderDto }) {
  const { t } = useTranslation();
  const errorMessage = useErrorMessage();
  const [open, setOpen] = useState(false);
  const bounds = usePriceSuggestion(order.fromCity.id, order.toCity.id, order.sizeClass);
  const min = order.price + 1000;
  const max = bounds.data?.max ?? min;
  const [price, setPrice] = useState<number | undefined>(Math.min(max, order.price + 5000));
  const raise = useOrderMutation((p: number) => raiseOrderPrice(order.id, p));

  if (order.priceRaisesLeft <= 0 || (bounds.data && max < min)) return null;
  if (!open) {
    return (
      <button
        type="button"
        className="btn-secondary w-full"
        onClick={() => {
          haptic.tap();
          setPrice(Math.min(max, order.price + 5000));
          setOpen(true);
        }}
      >
        💰 {t('order.raisePrice')}
      </button>
    );
  }
  const valid = price !== undefined && price >= min && price <= max;
  return (
    <Section title={t('order.raisePrice')}>
      <div className="space-y-2 p-3">
        <p className="text-sm text-hint">
          {t('order.raisePriceHint', {
            current: formatPrice(order.price, t('common.currency')),
            left: order.priceRaisesLeft,
          })}
        </p>
        <PriceInput
          value={price}
          onChange={setPrice}
          min={min}
          max={max}
          currency={t('common.currency')}
          invalid={!valid}
          label={t('order.raisePrice')}
        />
        <div className="flex gap-2">
          <button type="button" className="btn-secondary flex-1" onClick={() => setOpen(false)}>
            {t('common.cancel')}
          </button>
          <button
            type="button"
            className="btn-secondary flex-1 text-link"
            disabled={!valid || raise.isPending}
            onClick={() =>
              raise.mutate(price!, {
                onSuccess: () => {
                  haptic.success();
                  setOpen(false);
                },
                onError: () => haptic.error(),
              })
            }
          >
            {t('common.save')}
          </button>
        </div>
        {raise.isError && <p className="text-sm text-destructive">{errorMessage(raise.error)}</p>}
      </div>
    </Section>
  );
}
